import { ReactNode } from 'react';

interface RoutesWrapperProps {
  children: ReactNode;
}

/**
 * Wrapper component for routes
 */
export const RoutesWrapper = ({ children }: RoutesWrapperProps) => {
  return <>{children}</>;
};

export default RoutesWrapper;
